// extracted by mini-css-extract-plugin
export default {"container":"otp_container__H+RSm","otp":"otp_otp__ORSLy","inputStyle":"otp_inputStyle__U6j0Y","submit":"otp_submit__tZBTR","resend":"otp_resend__yossI","login":"otp_login__RZ+di"};